var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":`fade-${_vm.transitionName}`}},[(_vm.isVisible)?_vm._t("default"):_c('div',{key:"loading",ref:"background",staticClass:"loading-background"},[(_vm.showLoadingAnimation)?_c('loading'):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }